module.exports = __webpack_public_path__ + "img/EADesertHills20591.81bb8523.png";